import { Card, CardActionArea, CardContent, Grid, List } from "@mui/material";
import Typography from "antd/es/typography";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useRecoilValue } from "recoil";
import Api from "../API/api";
import { loginState, WHState } from "../Atom/AtomState";
import AlertComponent from "../CommonComponent/Alert/AlertComponent";
import ButtonComponent from "../CommonComponent/Inputs/ButtonComponent";
import TextComponent from "../CommonComponent/Inputs/TextComponent";
import Loading from "../CommonComponent/LoadingBar/Loading";
import PublicModal from "../CommonComponent/Modal/PublicModal";
import "../CSS/PageCSS/MemberPage.css";

const { Title } = Typography;

export default function MemberPage() {
  let navigate = useNavigate();
  const [employeeData, setEmployeeData] = useState<any>();
  const WH = useRecoilValue(WHState);
  const [divboxHeight, setdivBoxHeight] = useState<number>(0);
  const [searchInformation, setSearchInformation] = useState({
    name: "",
  });
  const [alert, setAlert] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");
  const [deleteModal, setDeleteModal] = useState({
    value: false,
    p_id: 0,
  });
  const LoginState = useRecoilValue(loginState);
  const [loading, setLoading] = useState(false);

  const changeTextField = (value: any) => {
    if (value.name == "name") {
      setSearchInformation((prev) => ({
        ...prev,
        name: value.value,
      }));
    }
  };

  const handleSearch = () => {
    const getSearch = async () => {
      setLoading(true);
      const employee = await Api.get(
        `/Employee/getEmployeeSearch?name=${searchInformation.name}`
      );
      setLoading(false);
      if (employee != undefined) {
        setEmployeeData(employee);
      } else {
        setAlert(true);
        setAlertMessage("데이터 조회에 실패하였습니다.");
      }
    };
    getSearch();
  };
  const handleUpdate = (item: any) => {
    if (item.p_id == 1) {
      setAlert(true);
      setAlertMessage("해당 직원은 수정이 불가능합니다.");
    } else {
      navigate("/MemberDetailPage", {
        state: { p_id: item.p_id, state: "update" },
      });
    }
  };

  const handleRegister = () => {
    navigate("/MemberDetailPage", {
      state: { state: "register" },
    });
  };

  const handleDelete = (item: any) => {
    if (item == 1) {
      setAlert(true);
      setAlertMessage("해당 직원은 삭제가 불가능합니다.");
    } else {
      const getDelete = async () => {
        setLoading(true);
        const deletedata = await Api.delete(
          `/Employee/deleteEmployee?p_id=${item}`
        );
        setLoading(false);
        if (deletedata != undefined) {
          navigate(0);
        } else {
          setAlert(true);
          setAlertMessage("직원 삭제에 실패하였습니다.");
        }
      };
      getDelete();
    }
  };

  useEffect(() => {
    if (!LoginState?.manager) {
      navigate("/");
    } else {
      const getData = async () => {
        setLoading(true);
        const employee = await Api.get("/Employee/getEmployeeList");
        setLoading(false);
        if (employee != undefined) {
          setEmployeeData(employee);
        } else {
          setAlert(true);
          setAlertMessage("데이터 조회에 실패하였습니다.");
        }
      };
      getData();
    }
  }, []);

  useEffect(() => {
    const handleResize = () => {
      const div = document.getElementById("divbox") as HTMLElement;
      const MembersearchTextDiv = document.getElementById(
        "MembersearchTextDiv"
      ) as HTMLElement;
      if (div && MembersearchTextDiv) {
        setdivBoxHeight(
          div.clientHeight - MembersearchTextDiv.clientHeight - 20
        );
      }
    };

    window.addEventListener("resize", handleResize);
    handleResize();

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  });

  return (
    <div style={{ height: WH.height - 160 }}>
      <Title level={2} className="MemberTitle">
        MemberPage
      </Title>
      <div id="divbox">
        <div className="MembersearchTextDiv" id="MembersearchTextDiv">
          <TextComponent
            variant="filled"
            value={searchInformation.name}
            label="직원이름"
            name="name"
            placeholder="검색어를 입력해주세요."
            onChange={changeTextField}
            className="MemberSearch"
          />
          <ButtonComponent
            fullWidth
            variant="contained"
            className="MembersearchTextDiv_searchButton"
            onClick={handleSearch}
          >
            검색
          </ButtonComponent>
          <ButtonComponent
            fullWidth
            variant="contained"
            onClick={handleRegister}
          >
            등록
          </ButtonComponent>
        </div>
        <List
          sx={{
            height: divboxHeight,
          }}
          className="MemberList"
        >
          <Grid container spacing={2}>
            {employeeData &&
              employeeData.map((item: any) => {
                return (
                  <Grid
                    key={item.p_id}
                    size={{ xs: 12, sm: 6, md: 6, lg: 4, xl: 3 }}
                  >
                    <Card
                      className="MemberCard"
                      onClick={() =>
                        navigate("/MemberDetailPage", {
                          state: { p_id: item.p_id, state: "view" },
                        })
                      }
                    >
                      <CardActionArea>
                        <CardContent className="MemberCardContent">
                          {item.manager == 1 ? (
                            <div className="MemberManager">관리자</div>
                          ) : (
                            <div className="MemberConsult">컨설턴트</div>
                          )}
                          <div>
                            <Title level={5} className="MemberName">
                              {item.name}
                            </Title>
                          </div>
                          <div className="MemberControlDiv">
                            <ButtonComponent
                              fullWidth
                              variant="contained"
                              onClick={(e) => {
                                e.stopPropagation();
                                handleUpdate(item);
                              }}
                              className="MemberUpdateButton"
                            >
                              수정
                            </ButtonComponent>
                            <ButtonComponent
                              fullWidth
                              variant="contained"
                              onClick={(e) => {
                                e.stopPropagation();
                                setDeleteModal({
                                  value: true,
                                  p_id: item.p_id,
                                });
                              }}
                              className="MemberDeleteButton"
                            >
                              삭제
                            </ButtonComponent>
                          </div>
                        </CardContent>
                      </CardActionArea>
                    </Card>
                  </Grid>
                );
              })}
          </Grid>
        </List>
      </div>
      {deleteModal && (
        <PublicModal
          open={deleteModal.value}
          onClose={(value: any) => {
            if (value) {
              handleDelete(deleteModal.p_id);
            }
            setDeleteModal({
              value: false,
              p_id: 0,
            });
          }}
          message={"삭제하시겠습니까?"}
          cancel={true}
        />
      )}
      {alert && (
        <AlertComponent value={alert} setValue={setAlert} info="error">
          {alertMessage}
        </AlertComponent>
      )}
      {loading && <Loading />}
    </div>
  );
}
